import React from "react";
import Globals from "../../api";
//import Safe from "react-safe"
// import { Gpt } from 'react-gpt-ads';
import { Bling as GPT } from "react-gpt";
import ReactHtmlParser from "react-html-parser";
import { Helmet } from "react-helmet";  
GPT.enableSingleRequest();
//Gpt.enableSingleRequest();
export default class Article_bottom_text extends React.Component {
  render() {
    return (
      <>
       <Helmet>
       <script src="https://cnt.trvdp.com/js/1090/4635.js"></script>
      </Helmet>
      <div></div>
     
      </>
    );
  }
}
